import React from "react";

import { shouldDisableAddToCart } from "@utils/disableAddToCart";
import { StockLevels } from "@utils/enums";

import { useGranite } from "@redux/modules/value/translations/translations.provider";

import { Button } from "@components/General/Button/button.component";

import { useStorePickerContext } from "../../storePicker.context";
import { StorePickerType } from "../../types/storePickerType.enum";

export const StorePickerFooterComponent = () => {
    const { t } = useGranite();

    const { config, selectedStore, submit } = useStorePickerContext();

    if (config.type === StorePickerType.INFO) return null;

    const isDisabled = () => {
        if (!selectedStore) return true;

        if (!config.displayStockLevel) return false;

        if (shouldDisableAddToCart(selectedStore?.productAvailability)) {
            return true;
        }

        const stockLevel = selectedStore.productAvailability?.stockLevel;

        return (
            stockLevel === StockLevels.NoStock ||
            stockLevel === StockLevels.UnknownStock
        );
    };

    return (
        <div className="storePicker-layout--footer">
            <p className="d-none d-md-block">
                {config.displayStockLevel &&
                    t("general.storepicker.label.pickupTime")}
                {config.infoLink && (
                    <a href={config.infoLink} className={"ml-1"}>
                        {t("general.storepicker.label.aboutCNC")}
                    </a>
                )}
            </p>
            {config.type === StorePickerType.SELECT && (
                <Button
                    test="storePicker-button-submit"
                    onClick={submit}
                    disabled={isDisabled()}
                    type={"button"}
                    fullWidth={true}
                >
                    <strong>
                        {config.submitButtonText ||
                            t("general.storepicker.button.confirmStore")}
                    </strong>
                </Button>
            )}
            {config.type === StorePickerType.CUSTOM && (
                <config.SubmitComponent />
            )}
        </div>
    );
};
